module.exports = __webpack_public_path__ + "img/crosshairs-solid.9a595a68.svg";